// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { HttpClientInstance } from "@toggl/sync/http";
import {
  LivetestCreateTestResponse,
  LivetestGetTestResponse,
  LivetestLiveTestAnswer,
  LivetestPostCopyPasteEvents,
  LivetestResults,
  LivetestStartTestBody,
  LivetestTestFeedback,
} from "../types";

export async function uploadNotification(
  httpClient: HttpClientInstance,
  upload_id: number,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`integrations/cloudinary/upload_notifications/${upload_id}`, {
      signal,
    })
    .json<unknown>();
  return response;
}

export async function getTest(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  slug: string,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .get(`jobopenings/${job_opening_slug}/tests/${slug}`, { signal })
    .json<LivetestGetTestResponse>();
  return response;
}

export async function startTest(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  slug: string,
  data: LivetestStartTestBody,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`jobopenings/${job_opening_slug}/tests/${slug}`, {
      signal,
      json: data,
    })
    .json<LivetestCreateTestResponse>();
  return response;
}

export async function patchTest(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  slug: string,
  data: Partial<LivetestLiveTestAnswer>,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .patch(`jobopenings/${job_opening_slug}/tests/${slug}`, {
      signal,
      json: data,
    })
    .json<unknown>();
  return response;
}

export async function postTestCopyPasteEvents(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  slug: string,
  data: LivetestPostCopyPasteEvents,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`jobopenings/${job_opening_slug}/tests/${slug}/copy-paste`, {
      signal,
      json: data,
    })
    .json<unknown>();
  return response;
}

export async function postTestFeedback(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  slug: string,
  data: LivetestTestFeedback,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`jobopenings/${job_opening_slug}/tests/${slug}/feedback`, {
      signal,
      json: data,
    })
    .json<unknown>();
  return response;
}

export async function finishTest(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  slug: string,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .patch(`jobopenings/${job_opening_slug}/tests/${slug}/finish`, { signal })
    .json<LivetestResults>();
  return response;
}

export async function tryTest(
  httpClient: HttpClientInstance,
  job_opening_slug: string,
  slug: string,
  signal?: AbortSignal,
) {
  const response = await httpClient
    .post(`jobopenings/${job_opening_slug}/tests/${slug}/try`, { signal })
    .json<unknown>();
  return response;
}
